import { useDispatch } from 'react-redux';
import {
  AlertColor,
  AlertVariant,
  Direction,
  ToastSize,
} from '../types/ToastTypes';
import { clearToasts, hideToast, showToast } from '../store';

type ToastOptions = {
  message: string;
  type?: AlertColor;
  delay?: number;
  direction?: Direction;
  variant?: AlertVariant;
  size?: ToastSize;
};

let toastCounter = 0;
const nextToastId = () => `toast-${Date.now()}-${(toastCounter += 1)}`;

export const useToast = () => {
  const dispatch = useDispatch();

  const triggerToast = ({
    message,
    type = 'primary',
    delay = 5000,
    direction = 'top-right',
    variant = 'outlined',
    size = 'md',
  }: ToastOptions) => {
    const id = nextToastId();
    dispatch(showToast({ id, message, type, direction, variant, size }));
    // Each toast owns its own timer, so a new toast never cuts short the ones
    // already on screen.
    setTimeout(() => dispatch(hideToast(id)), delay);
    return id;
  };

  const closeToast = (id?: string) => {
    if (id) dispatch(hideToast(id));
    else dispatch(clearToasts());
  };

  return [triggerToast, closeToast] as const;
};
